import { Drawer } from '../shared/Drawer';
import { QuizQuestionStep } from './QuizQuestionStep';
import { QuizResult } from './QuizResult';
import { QuizResultFooter } from './QuizResultFooter';
import { useSkinQuiz } from './useSkinQuiz';
import { useOverlayActions } from '../../contexts/StoreContext';
import { founder, salon } from '../../data/content';
import { shopLabels } from '../../data/shopLabels';
import { btnPrimary } from '../../ui/styles';

/**
 * Huidadvies in één minuut: vier vragen, dan een protocol. Bij de uitslag staat de hoofdknop
 * vast onderaan de lade; klein beginnen, de salon en "mail het me" staan in de uitslag zelf.
 */
export function SkinQuiz() {
  const q = useSkinQuiz();
  const {
    openBooking
  } = useOverlayActions();
  const showResult = !q.question && q.result && q.totals;
  return <Drawer open={q.open} onClose={q.close} title="Huidtest in 1 minuut" footer={showResult && q.result && q.totals ? <QuizResultFooter result={q.result} totals={q.totals} onClose={q.close} data-id="element-8508" data-mp="60graeh02nds" /> : undefined} data-id="element-8507" data-mp="axz2ycmejgph">
      {q.question ? <QuizQuestionStep question={q.question} step={q.step} total={q.total} onAnswer={q.answer} onBack={q.back} data-id="element-8509" data-mp="2aa0ckqv995bf" /> : !q.result || !q.totals ?
    // Geen protocollen in de catalogus: de quiz eindigde voorheen in een lege lade.
    <div className="text-center" data-id="element-8510" data-mp="2p5prk520wi6n">
          <h3 className="font-display text-2xl font-light text-ink" data-id="element-8511" data-mp="2p6rcr2cr6l23">Dank je voor je antwoorden</h3>
          <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-8512" data-mp="2t68jdz3x1o8u">
            Er staat nu geen protocol online dat ik je kan aanraden. Stuur me een appje, dan kijk ik persoonlijk mee.
          </p>
          <a href={salon.whatsapp} target="_blank" rel="noreferrer" className={`${btnPrimary} mt-6`} data-id="element-8513" data-mp="32x37l90q2xwx">
            App {founder.firstName}
            <span className="sr-only" data-id="element-8514" data-mp="3cur68a1g8pkd">{shopLabels.viaWhatsApp}</span>
          </a>
          <button type="button" onClick={q.reset} className="mt-3 block w-full px-2 py-2 text-[14px] text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-8515" data-mp="3csxuwhfw5h61">
            Opnieuw doen
          </button>
        </div> : <QuizResult result={q.result} totals={q.totals} gift={q.gift} starter={q.starter} treatment={q.treatment} answers={q.answers} round={q.round} onClose={q.close} onCloseKeep={q.closeKeep} onRestart={q.reset} onBookTreatment={slug => {
      // De antwoorden blijven staan: wie terugkomt, ziet het advies nog.
      q.closeKeep();
      openBooking(slug);
    }} data-id="element-8516" data-mp="1ctaqwp077m37" />}
    </Drawer>;
}